import {z} from 'zod'

export const FloorPlanDevice = z.object({
    id: z.string(),
    label: z.string()
})
export type FloorPlanDevice = z.infer<typeof FloorPlanDevice>
